import React from 'react';

export const ERROR_OUTLINE_STYLE: React.CSSProperties = {
  borderRadius: 'var(--border-radius-md)',
  outline: 'solid var(--border-width) var(--error-color)',
  outlineOffset: '-1px'
};

export const ERROR_BORDER_STYLE: React.CSSProperties = {
  borderRadius: 'var(--border-radius-md)',
  border: 'solid var(--border-width) var(--error-color)'
};
